import React from 'react';
import { useMainCategoryList } from './useMainCategoryList';
import Select from '../../../../../../components/input/Select';
import { addAllItemToSelectList } from '../../../../../../lib/common';
import { MainCategoryItemV2 } from '../../../../../../types/category';

interface MainCategorySelectProps {
  list?: MainCategoryItemV2[];
  value?: number | null;
  onChange: (value: number | null) => void;
}

const MainCategorySelect = (props: MainCategorySelectProps) => {
  const { value, onChange } = props;

  const mainCategoryList = useMainCategoryList();

  return (
    <Select
      value={value}
      onChange={onChange}
      list={addAllItemToSelectList(mainCategoryList)}
      defaultValue={null}
      isTable={true}
      size="large"
    />
  );
};

export default MainCategorySelect;
